import React from 'react';

const Slider = ({minVal, maxVal, stepVal, val, defVal, setVal, inputType}) => (
  <input
    type={inputType}
    min={minVal}
    max={maxVal}
    step={stepVal}
    value={val && val}
    defaultValue={defVal && defVal}
    onChange={(e) => setVal(inputType === "range" ? +e.target.value : e.target.value)}
  />
);

export default Slider;
